"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateProgramAccuracy = void 0;
const IrisData_1 = require("../../../data/IrisData");
function getNode(programData, nodeIdx, inputs) {
    const num_in = inputs.length;
    if (nodeIdx < inputs.length) {
        return inputs[nodeIdx];
    }
    const idxL = parseInt(programData[(nodeIdx - num_in) * 3]);
    const idxR = parseInt(programData[(nodeIdx - num_in) * 3 + 1]);
    const operation = programData[(nodeIdx - num_in) * 3 + 2];
    //return `(getNode(data, ${idxL}, num_in)} ${operation} getNode(data, ${idxL}, num_in))`;
    if (operation === "+") {
        return (getNode(programData, idxL, inputs) + getNode(programData, idxR, inputs));
    }
    if (operation === "-") {
        return (getNode(programData, idxL, inputs) - getNode(programData, idxR, inputs));
    }
    if (operation === "*") {
        return (getNode(programData, idxL, inputs) * getNode(programData, idxR, inputs));
    }
    throw `Unknown operation: ${operation}`;
}
function evaluateProgramAccuracy(program, num_in, num_mid, num_out) {
    const programData = program.split(" ");
    const output = new Array();
    let correct = 0;
    let total = 0;
    for (const data of IrisData_1.IrisData) {
        // Get our inputs:
        const inputs = [data[0], data[1], data[2], data[3]];
        // Get our outputs:
        const outputs = new Array();
        for (let i = 0; i < num_out; i++) {
            const ptr = programData[i + num_mid * 3];
            const output = getNode(programData, parseInt(ptr), inputs);
            outputs.push(output);
        }
        const guessIdx = outputs.indexOf(Math.max(...outputs));
        const correctIdx = [
            "Iris-setosa",
            "Iris-versicolor",
            "Iris-virginica",
        ].indexOf(data[4]);
        if (guessIdx === correctIdx) {
            correct = correct + 1;
        }
        total = total + 1;
    }
    return correct / total;
}
exports.evaluateProgramAccuracy = evaluateProgramAccuracy;
function evaluateProgramFitness(program, num_in, num_mid, num_out) {
    const programData = program.split(" ");
    const output = new Array();
    const fitnesses = new Array();
    for (const data of IrisData_1.IrisData) {
        // Get our inputs:
        const inputs = [data[0], data[1], data[2], data[3]];
        // Get our outputs:
        const outputs = new Array();
        for (let i = 0; i < num_out; i++) {
            const ptr = programData[i + num_mid * 3];
            const output = getNode(programData, parseInt(ptr), inputs);
            outputs.push(output);
        }
        //console.log(`Outputs: ${outputs}`);
        const correctIdx = [
            "Iris-setosa",
            "Iris-versicolor",
            "Iris-virginica",
        ].indexOf(data[4]);
        const totalE = outputs
            .map((o) => Math.exp(o))
            .reduce((sum, current) => sum + current, 0);
        const predictedE = Math.exp(outputs[correctIdx]);
        const fitness = Math.log(predictedE / totalE);
        //console.log(`Fitness: ${fitness}`);
        fitnesses.push(fitness);
    }
    const average = fitnesses.reduce((a, b) => a + b) / fitnesses.length;
    return average;
}
exports.default = evaluateProgramFitness;
